module.exports = __webpack_public_path__ + "static/media/devices.0dca6dab.png";